module.exports = __webpack_public_path__ + "img/n13.a5662fea.png";